import Button from "./Button"
import ProfilePic from "./ProfilePic"

const Card = (props) => {
  const { card } = props;
  return(
    <div id="Card" className="col-12 col-md-4 col-lg-3">
      <div>
        <video 
          autoPlay={card.id === 1} 
          muted={card.id === 1} 
          loop={card.id === 1} 
          src={require(`../assets/video/${card.video}`).default} />  
        <div className="gradient"></div>
        <div className="body">
          <ProfilePic
          url={require(`../assets/img/${card.profileIMG}`).default} />
          <p className ="name">{card.name}</p>
          <p className ="username">{card.username}</p>
          <Button text={"Follow"} type={"primary"}/>
        </div>
      </div>
    </div>
  )
}

export default Card;